export enum Routenames {
    Home = '',
    Login = 'inloggen',
    Logout = 'uitloggen',
    ForgotPassword = 'wachtwoord-vergeten',
    Twofactor = 'tweestapsverificatie',
    TwofactorSetup = 'tweestapsverificatie/setup',
    ValidateUserEmail = 'valideer-gebruikers-email',
    Users = 'gebruikers',
    Projects = 'projecten',
    Drawings = 'tekeningen',
    Map = 'kaart',
    TtmTickets = 'tickets',
    AuthMatrix = 'rechtenmatrix',
    WorkOrders = 'werkopdrachten',
    WorkOrderImages = 'werkorder-afbeeldingen',
    TtmImageView = 'ttm-afbeelding',
    ExportInterface = 'koppelingen',
    CreatePart = 'nieuw',
    UserInsight = 'gebruikersinzichten',
}
